import context from '../context';
import { SHIFT_BLOCK_SOURCES } from '../constants';

export default function getShiftAppearanceToDisplay(removeTags = false, appearanceObj = null) {
  const displayShiftAppearance = appearanceObj
    ? { ...appearanceObj }
    : { ...context.shiftAppearance };
  return _filterShiftAppearance(displayShiftAppearance, removeTags);
}

function _filterShiftAppearance(displayShiftAppearance, removeTags) {
  const tempAppearance = {};

  Object.keys(context.shiftAppearance).forEach((displayMode) => {
    tempAppearance[displayMode] = {};
    Object.keys(context.shiftAppearance[displayMode]).forEach((key) => {
      if (!Array.isArray(displayShiftAppearance[displayMode][key])) {
        tempAppearance[displayMode][key] = [];
        return;
      }

      tempAppearance[displayMode][key] = displayShiftAppearance[displayMode][key].filter((t) =>
        _isTypeSupported(t, removeTags)
      );
    });
  });

  return tempAppearance;
}

function _isTypeSupported(type, removeTags) {
  const { isOrgFeatureEnabled } = context;

  let isSupported = Object.keys(SHIFT_BLOCK_SOURCES).includes(type);

  const tagsDisabled =
    removeTags || !isOrgFeatureEnabled('tags') || !context.tags || !context.tags.length;
  if (type === SHIFT_BLOCK_SOURCES.TAG && tagsDisabled) {
    isSupported = false;
  }

  return isSupported;
}
